module.exports = __webpack_public_path__ + "static/img/logo.28bed634.jpg";